// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__172xw","label":"Category_label__k121a","content":"Category_content__Jb0PK","header":"Category_header__3P_w_","location":"Category_location__3kJ2v"};